module.exports = __webpack_public_path__ + "static/img/chuangongan.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chuangongan.png
// module id = EeMD
// module chunks = 33